import * as React from 'react';
import styled from 'styled-components';
import { inject, observer } from 'mobx-react';
import { IInjectedProps } from '../../../interface/component/injected-props.interface';
import { getCenterOfPageStyle } from '../../../util/style/get-center-of-page-style';
import { BlockColorEnum } from '../../../enum/block-color.enum';
import { CheckMarkIcon } from '../../icons';

interface ISubmittedFormProps {
  successHeader: string;
  successBody: string;
  blockColor: string;
  boxColor: string;
}

const BoxWrapper = styled.div`
  padding:14px 12px 14px 12px;
  color: ${BlockColorEnum.SecondaryTextColor};
  font-size: 18px;
  border-radius: 3px;
  display: flex;
  flex-direction: row;
  background: ${(props: { background: string }) => props.background};
  ${getCenterOfPageStyle()};
`;

const BlockWrapper = styled.div`
  padding:70px 0 70px 0;
  background: ${(props: { background: string }) => props.background};
`;

const HeaderWrapper = styled.div`
  margin-bottom: 10px;
`;
const BodyWrapper = styled.div``;
const HeaderAndBodyWrapper = styled.div`
  display:flex;
  flex-direction: column;
  flex: 1;
`;
const IconWrapper = styled.div`
  width: 24px;
  margin-right: 13px;
`;

@inject('state')
@observer
export class SubmittedForm extends React.Component<ISubmittedFormProps & IInjectedProps> {
  render() {
    const props = this.props;
    const {successHeader, successBody, blockColor, boxColor} = props;
    return (
      <BlockWrapper background={blockColor}>
        <BoxWrapper background={boxColor}>
          <IconWrapper>
            <CheckMarkIcon color={this.props.state.blockColors.SecondaryTextColor}/>
          </IconWrapper>
          <HeaderAndBodyWrapper>
            <HeaderWrapper>
              {successHeader}
            </HeaderWrapper>
            <BodyWrapper>
              {successBody}
            </BodyWrapper>
          </HeaderAndBodyWrapper>
        </BoxWrapper>
      </BlockWrapper>
    );
  }
}
